angular.module('impactx.selectionDialog').directive('appSelectionDialog', [function() {
    return {
        scope: {
            trns: '=',
            isSuperUser: '=',
            sets: '=',
            fillWords: '=',
            companyTypePopup: "=",
            companyPopup: "=",
            companyRelationPopup: "=",
            selectionId: "=",
            updateFunction: "&"
        },
        restrict: 'E',
        templateUrl: 'shared/selectiondialog/templates/selectiondialog.html',
        link: function(scope, element) {
            var formController = element.controller('form');
            if(formController) {
                scope.formController = formController;
            }
        }
    };
}]);